import animation, { cubicBezierBackgroundColor } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  smallcapsBold13Styles,
  smallcapsBold14Styles,
} from "@constants/typography"
import React from "react"
import styled from "styled-components"

import AnimatedDash, { animationStyles } from "../common/AnimatedDash"

const whiteProps = `
  color: ${colors.black};
  background-color: ${colors.white};
  border: solid 1px ${colors.black};

  &:active {
    background-color: ${colors.white};
  }

  @media ${breakpoints.laptop} {
    color: ${colors.black};

    &:hover {
      background-color: ${colors.white};
    }
  }
`

export const disabledProps = `
  color: ${colors.mediumGray};
  background-color: ${colors.disabledGray};

  @media ${breakpoints.laptop} {
    color: ${colors.mediumGray};
    background-color: ${colors.disabledGray};

    &:hover {
      cursor: not-allowed;
      color: ${colors.mediumGray};
      background-color: ${colors.disabledGray};
    }
  }
`

export const StyledButton = styled.button<any>`
  ${smallcapsBold13Styles}
  display: flex;
  position: relative;
  height: 48px;
  width: 100%;
  padding: 0 24px;
  align-items: center;
  justify-content: space-between;
  color: ${colors.offWhite};
  background-color: ${colors.black};
  border-radius: 2px;
  border: none;
  transition: background-color ${animation.medium} ${cubicBezierBackgroundColor};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:active {
    background-color: ${colors.black};
    transition: none;
  }

  ${animationStyles}

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
    color: ${colors.offWhite};

    &:hover {
      background-color: ${colors.hoverBlack};
    }
  }

  ${({ $buttonStyles }) => ($buttonStyles ? $buttonStyles : "")}
  ${({ $white }) => ($white ? whiteProps : "")}
  ${({ disabled }) => (disabled ? disabledProps : "")}
  ${({ $borderStyle }) =>
    $borderStyle
      ? `border: ${$borderStyle};`
      : `border: solid 1px ${colors.black};`}
`

// Interstate padding
export const Text = styled.span<{ $hideDash?: boolean }>`
  width: ${({ $hideDash }) => ($hideDash ? "100%" : "auto")};
  padding-top: 3px;
  padding-right: ${({ $hideDash }) => ($hideDash ? "0" : "24px")};
  line-height: 18px;
  text-align: ${({ $hideDash }) => ($hideDash ? "center" : "left")};
`

export interface ButtonProps {
  borderStyle?: string
  className?: string
  disabled?: boolean
  hideDash?: boolean
  onClick?: any
  text: string
  type?: "button" | "reset" | "submit"
  white?: boolean
}

const Button = ({
  borderStyle,
  className,
  disabled,
  hideDash,
  onClick,
  text,
  type = "button",
  white,
}: ButtonProps) => (
  <StyledButton
    $borderStyle={borderStyle}
    $white={white}
    aria-label={text}
    className={className}
    disabled={disabled}
    onClick={onClick}
    type={type}
  >
    <Text $hideDash={hideDash}>{text}</Text>
    {!hideDash && <AnimatedDash color={white ? colors.black : colors.white} />}
  </StyledButton>
)

export default Button
